import { reactive } from 'vue'
import type { Release, ReleaseStatus } from '@/types'

export interface ReleasesState {
  releases: Release[]
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: ReleaseStatus | ''
    projectId: string
  }
}

export const getInitialState = (): ReleasesState => ({
  releases: [],
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    projectId: '',
  },
})

export const createState = (): ReleasesState => {
  return reactive<ReleasesState>(getInitialState())
}

export const resetState = (state: ReleasesState): void => {
  const initial = getInitialState()
  state.releases = initial.releases
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
